import { useState } from 'react';
import { Select, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { salesApi } from '../../api/endpoints/sales';

interface SaleSelectProps {
  value?: number | null;
  onChange?: (value: number | undefined) => void;
  placeholder?: string;
  accountId?: number;
  allowClear?: boolean;
}

export function SaleSelect({
  value,
  onChange,
  placeholder = 'Buscar venta…',
  accountId,
  allowClear = true,
}: SaleSelectProps): JSX.Element {
  const [search, setSearch] = useState('');

  const { data, isFetching } = useQuery({
    queryKey: ['sales', 'lookup', search, accountId],
    queryFn: () =>
      salesApi.list({
        page: 1,
        pageSize: 20,
        search: search || undefined,
        accountId,
      }),
  });

  const options =
    data?.data.map((s) => ({
      label: s.saleNumber ? `${s.saleNumber} · ${s.name}` : s.name,
      value: s.id,
    })) ?? [];

  return (
    <Select
      showSearch
      allowClear={allowClear}
      placeholder={placeholder}
      value={value ?? undefined}
      onChange={(v) => onChange?.(v ?? undefined)}
      onSearch={setSearch}
      filterOption={false}
      notFoundContent={isFetching ? <Spin size="small" /> : 'Sin resultados'}
      options={options}
      style={{ width: '100%' }}
    />
  );
}
